import { combineReducers } from 'redux'
import authReducer from './auth';
import casinoReducer from './casino';
import userReducer from './user';

export default combineReducers({
    casino : casinoReducer,
    auth : authReducer,
    user: userReducer
})